export type VolumeCapsuleView = 'chart' | 'values';

export interface VolumeCapsuleConfigState {
    symbol?: string;
    showQuantitiesOnScale: boolean;
    view: VolumeCapsuleView;
}

export const initialVolumeCapsuleConfigState: VolumeCapsuleConfigState = {
    showQuantitiesOnScale: false,
    view: 'chart',
};
